import { APPSTATE, LAYOUTSTATE } from '..'
import { FloaterLocations } from '../../../types/state'
import { getDefaultDivision } from '../../components/presentation/Chat/common/utilities'
import { RoomView, ViewMode } from '../../constants/enums'
import { QUICK_REPLY } from '../../constants/floaters'
import { calcRoomGeometry } from '../../mfcLogic/roomGeometry'
import { isTouchDevice } from '../../utilities/browser'
import { getModalState, getScreenState } from '../getState'
import { updatePortalState } from './layout'
import { generateModalKey } from './modals'

export const getSafeOrientation = (
    isMobile: boolean,
    vertical: boolean,
    fullPage: boolean,
) => {
    if (isMobile) {
        return vertical ? 'portrait' : 'landscape'
    }
    if (fullPage) {
        return vertical ? 'portrait' : 'landscape'
    }
    return 'landscape'
}

export const recalcRoom = ({
    roomView,
    viewMode,
    expanded,
}: {
    roomView: RoomView
    viewMode: ViewMode
    expanded: boolean
}) => {
    const {
        portrait,
        roomWidth,
        roomHeight,
        contentWidth,
        contentHeight,
        windowWidth,
        windowHeight,
        roomX,
    } = getScreenState()

    const isFullWindow = viewMode === ViewMode.FullWindow
    const floatingRoom = getModalState().floating_room
    const usableWidth = portrait || expanded ? roomWidth : contentWidth
    const usableHeight = portrait || expanded ? roomHeight : contentHeight

    // 1) fill the locations with roomHeight/Width or contentHeight/Width
    const orientation = getSafeOrientation(
        APPSTATE.app.isMobile || isTouchDevice,
        portrait,
        true,
    )

    // a minimized room keeps its full size, ready for the restore
    const location = {
        width: isFullWindow ? windowWidth : usableWidth,
        height: isFullWindow ? windowHeight : usableHeight,
    }
    if (!LAYOUTSTATE.portal.division) {
        // set the default division so we aren't complicating room rendering with empty state handling
        updatePortalState({
            division: getDefaultDivision(location.width, location.height),
        })
    }

    const otherOrientation =
        orientation === 'portrait' ? 'landscape' : 'portrait'
    const locations = {
        [orientation]: location,
        [otherOrientation]: floatingRoom.locations[otherOrientation],
    } as FloaterLocations

    return {
        ...calcRoomGeometry({
            roomView,
            viewMode,
            width: usableWidth,
            height: usableHeight,
            windowWidth,
            windowHeight,
            roomX,
            division: LAYOUTSTATE.portal.division,
            isMobile: APPSTATE.app.isMobile,
            pmListCollapsed: LAYOUTSTATE.portal.pmListCollapsed,
        }),
        locations,
    }
}

export const isQuickReplyOpen = (id: number, checkMinimized?: boolean) => {
    const quickReply =
        getModalState().floater[generateModalKey(QUICK_REPLY, id)]
    if (checkMinimized) return quickReply?.show && !quickReply?.minimized
    return quickReply?.show
}
